import { render } from "./NewBusinessRuleActionSendNotification.vue?vue&type=template&id=e8978e3e"
import script from "./NewBusinessRuleActionSendNotification.vue?vue&type=script&lang=js"
export * from "./NewBusinessRuleActionSendNotification.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__